module.exports = __webpack_public_path__ + "static/media/alert_rieltor_gift@2x.4011bfbe.png";